export default __webpack_public_path__ + "static/media/plus-icon.07115908.svg";